import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, Provider } from '@angular/core';

import { AuthConfig, AuthHttpInterceptor, provideAuth0 as provideBaseAuth0 } from '@auth0/auth0-angular';

import { CamMainRoute, CamRoutes } from '@camelot/menu';

import { CAM_AUTH_TOKEN } from '../services/auth.service';
import { CamAuth0Service } from './auth0.service';

const rewriteSafeAuth0UrlFactory = () => {
  return () => {
    const href = window.location.href;
    if (!href.includes(CamRoutes.getUrl([CamMainRoute.REDIRECT]))) {
      return;
    }
    if (!href.includes('state=') || !href.includes('code=')) {
      return;
    }
    window.location.href = href.replace(/state=/g, 'myState=').replace(/code=/g, 'myCode=');
  };
};

export interface CamAuth0Environment extends AuthConfig {}

export const provideAuth0 = (data: { config: CamAuth0Environment }): Provider => [
  provideBaseAuth0(data.config),
  {
    provide: APP_INITIALIZER,
    useFactory: rewriteSafeAuth0UrlFactory,
    multi: true,
  },
  { provide: CAM_AUTH_TOKEN, useClass: CamAuth0Service },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHttpInterceptor,
    multi: true,
  },
];
